export default "<ion-content class=\"ion-padding\">\n  <div>Check your Withdrawal History</div>\n</ion-content>\n"